export const SCRIPT_TABLE_COLUMNS = [
  {
    key: 'name',
    label: 'Script Name',
    headerStyle: 'min-w-200px',
    isSorted: true,
  },
  {
    key: 'description',
    label: 'Script Description',
    headerStyle: 'min-w-250px',
    isSorted: true,
  },
  {
    key: 'placement',
    label: 'Placement',
    headerStyle: 'min-w-120px',
    isSorted: true,
  },
  {
    key: 'updated_by',
    label: 'Updated By',
    headerStyle: 'min-w-150px',
    isSorted: true,
  },
  {
    key: 'updated_at',
    label: 'Updated At',
    headerStyle: 'min-w-150px',
    isSorted: true,
  },
  {
    key: 'created_at',
    label: 'Created At',
    headerStyle: 'min-w-150px',
    isSorted: true,
  },
  {
    key: 'action',
    label: 'Action',
    headerStyle: 'w-80px text-center',
    isSorted: false,
  },
]

export const PLACEMENT_OPTIONS = [
  {
    value: 'footer',
    label: 'Footer',
  },
  {
    value: 'header',
    label: 'Header',
  },
]

export const SCRIPT_DEFAULT_VALUES = (isEdit: boolean, script: any) => ({
  name: isEdit ? script?.name : '',
  description: isEdit ? script?.description : '',
  placement: isEdit ? script?.placement : 'footer',
  content: isEdit ? script?.content : '',
})

export const SCRIPT_FORM_VALIDATION = {
  name: {
    required: 'Script name is required',
    maxLength: {
      value: 100,
      message: 'Script name cannot exceed 100 characters'
    }
  },
  description: {
    maxLength: {
      value: 250,
      message: 'Description cannot exceed 250 characters'
    }
  },
  placement: {
    required: 'Placement is required'
  },
  content: {
    required: 'Script content is required'
  }
}
